/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AddLoanPage = lazyLoad(
  () => import('./index'),
  module => module.AddLoanPage,
);
